import { PropsWithChildren, ReactElement } from "react";
import styles from "./CardStatus.module.less";
import { setTrackingId } from "client/Misc/utils";

export type CardStatusProp = {
	trackingId: string;
};
export const CardStatus = (props: PropsWithChildren<CardStatusProp>): ReactElement => {
	const {
		trackingId
	} = props;
	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			{props.children}
		</div>
	);
};
CardStatus.displayName = "CardStatus";